import React from 'react';
import overrideStyle from 'lib/overrideStyle';

import ChatHistoryContainer from 'presentation/containers/ChatHistoryContainer';
import FooterContainer from 'presentation/components/Footer';

export default function Chat() {
  return (
    <Wrapper data-aid="selfService-chat">
      <ChatHistoryContainer />
      <FooterContainer />
    </Wrapper>
  );
}

const Wrapper = overrideStyle('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
